import { createSelector } from '@ngrx/store';
import * as fromFeature from '@app/shared/store/reducers';
import * as fromFilial from '@app/shared/store/reducers/filial.reducers';

export const selectFilialState = createSelector(
  fromFeature.selectSharedFeatureState,
  (state: fromFeature.State) => state.filials
);

export const getFilialsByCity = createSelector(
  selectFilialState,
  fromFilial.getFilialsByCity
);

export const getFilials = createSelector(
  selectFilialState,
  fromFilial.getFilials
);
